<template>
  <AppBar title="User" />
  <h1>User</h1>
  <h1>this page is broken {{ isSuccess }}</h1>
  <p v-if="data">{{ JSON.stringify(data.data) }}</p>
  <div v-if="isPending" class="update">Loading...</div>
  <div v-else-if="isError">An error has occurred: {{ error }}</div>
  <div v-else-if="data">
    <h1>{{ data.data.id }} {{ data.data.login }} {{ data.data.full_name }}</h1>
    <div>
      <p>{{ data.data.email }}</p>
    </div>
    <div v-if="isFetching" class="update">Background Updating...</div>
  </div>
</template>
<script setup lang="ts">
import { useUserGetCurrent } from "../gen/forgejo-vue";

const { isPending, isError, isSuccess, isFetching, data, error } =
  useUserGetCurrent();
</script>
